const getters = {
	userInfo: state => state.userInfo.userInfo,
	storeCertNo: state => state.userInfo.userInfo.certNo,
	storeMobile: state => state.userInfo.userInfo.mobile
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js